import { useReduxState } from "../../explorer/redux/hooks";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";

export const useApiError: () => [string | undefined, (error: string | undefined) => void] = () => {
  const [error, setError] = useReduxState<string | undefined>(reduxStoreConfig.systemApiError);
  return [error, setError];
};
